import React from "react";
import { HANDOVER_DATA_BAR } from "constants/ui-constants";
import Masterbar from "./Masterbar";

export default () => <Masterbar {...HANDOVER_DATA_BAR} />;
